import Url from "url-parse";
const getAutoHost = (data) => {
  const HostMapsValue = (() => {
    return data.HostMaps.map((v) => {
      return Object.values(v);
    });
  })();
  let index = HostMapsValue.findIndex((v) => v.includes(data.host));
  if (!data.HostMaps[index]) {
    index = 0;
  }
  return {
    host: data.host,
    activate: data.HostMaps[index],
    other: data.HostMaps.filter((_, i) => {
      return i !== index;
    })
  };
};
const getHostTools = (data) => {
  const temp = {};
  data.other.forEach((v) => {
    Object.entries(v).forEach(([key, host]) => {
      temp[host] = data.activate[key];
    });
  });
  const replaceAutoHost = (url) => {
    const url_obj = new Url(url);
    if (url_obj.host === data.host) {
      return url;
    }
    const host = temp[url_obj.host];
    if (host) {
      url_obj.set("host", host);
    }
    return url_obj.href;
  };
  const replaceAutoHostBgImg = (str) => {
    let temp2 = str;
    const matched = String(str).match(/url\((["']?)(.*)?\1\)/);
    if (matched == null ? void 0 : matched[2]) {
      temp2 = `url('${replaceAutoHost(matched == null ? void 0 : matched[2])}')`;
    }
    return temp2;
  };
  const replaceAutoHostStyle = (style) => {
    const temp2 = style;
    if (temp2 == null ? void 0 : temp2.backgroundImage) {
      temp2.backgroundImage = replaceAutoHostBgImg(temp2.backgroundImage);
    }
    return temp2;
  };
  return {
    replaceAutoHost,
    replaceAutoHostBgImg,
    replaceAutoHostStyle
  };
};
const getHost = (data) => {
  const auto = getAutoHost({
    HostMaps: data.HostMaps[data.env],
    host: data.host
  });
  let prod = auto;
  if (data.env !== "prod") {
    prod = getAutoHost({
      HostMaps: data.HostMaps["prod"],
      host: data.host
    });
  }
  return {
    auto: auto.activate,
    prod: prod.activate,
    ...getHostTools(auto)
  };
};
export {
  getAutoHost,
  getHost,
  getHostTools
};
